import { useMachine } from "@xstate/react"
import React from "react"
import { Machine } from "xstate"

const ToggleMachine: React.FC<{
  children: (
    toggle: () => void,
    open: () => void,
    isOpen: () => boolean,
    close: () => void,
    isClose: () => boolean
  ) => any
}> = ({ children }) => {
  const toggleMachine = Machine({
    id: "toggle-machine",
    initial: "closed",
    states: {
      closed: {
        on: {
          TOGGLE_OPEN: "opened",
          TOGGLE: "opened",
        },
      },
      opened: {
        on: {
          TOGGLE_CLOSE: "closed",
          TOGGLE: "closed",
        },
      },
    },
  })

  const [current, send] = useMachine(toggleMachine)

  const close = () => send("TOGGLE_CLOSE")
  const open = () => send("TOGGLE_OPEN")
  const toggle = () => send("TOGGLE")
  const isOpen = () => current.matches("opened")
  const isClose = () => current.matches("closed")

  return <>{children(toggle, open, isOpen, close, isClose)}</>
}

export default ToggleMachine
